import {
  InvitationEmailEditHintPosition,
  InvitationEmailTemplateParts,
} from './generateInvitationEmailTypes';

export const CUSTOM_MESSAGE_PLACEHOLDER = '{{customMessage}}';

export function splitInvitationTemplateHtml(html: string): InvitationEmailTemplateParts {
  const customMessageIndex = html.indexOf(CUSTOM_MESSAGE_PLACEHOLDER);
  if (customMessageIndex !== -1) {
    return {
      before: html.substring(0, customMessageIndex),
      after: html.substring(customMessageIndex + CUSTOM_MESSAGE_PLACEHOLDER.length),
    };
  }

  return { before: html, after: '' };
}

export function stripCustomMessagePlaceholder(html: string): string {
  return html.replace(/{{customMessage}}/g, '');
}

export function computeEditHintPosition(
  containerEl: HTMLDivElement,
  position: { top: number; left: number },
): InvitationEmailEditHintPosition | null {
  const containerRect = containerEl.getBoundingClientRect();
  const relativeTop = position.top - containerRect.top;
  const relativeLeft = position.left - containerRect.left;

  const withinVerticalBounds = relativeTop >= -50 && relativeTop <= containerRect.height + 50;
  const withinHorizontalBounds = relativeLeft >= -50 && relativeLeft <= containerRect.width - 140;

  if (!withinVerticalBounds || !withinHorizontalBounds) {
    return null;
  }

  const normalizedTop = Math.min(
    Math.max(relativeTop, 16),
    Math.max(containerRect.height - 16, 16),
  );
  const normalizedLeft = Math.min(Math.max(relativeLeft, 16), containerRect.width - 140);

  return {
    top: normalizedTop,
    left: normalizedLeft,
    containerWidth: containerRect.width,
  };
}
